import { useContext, useEffect, useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { OverlayPanel } from "primereact/overlaypanel";
import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import { Button } from "primereact/button";
import { ObtenerLotesIdVendor } from "../../../../../../API/Logistica/PasesSalidaRequest";

const LotesOverlayPanel = ({ IdVendor, close, rowData, onChange }) => {
  const op = useRef(null);
  const buttom = useRef(null);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [lotes, setLotes] = useState([]);

  const fetchData = async () => {
    try {
      const response = await ObtenerLotesIdVendor(IdVendor);
      setLotes(response);
    } catch (error) {
      console.error("Error al llamar a la API:", error);
    }
  };

  const columns = [
    {
      // Comment
      field: "IdLote",
      header: "ID",
      headerEn: "ID",
      className: "colum-width-Xlarge",
      body: (rowData) => rowData.IdLote,
      frozen: "frozen",
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      header: "No. Lote",
      headerEn: "No. Lote",
      field: "NoLote",
      className: "large",
      frozen: true,
      body: (rowData) => ({ ID: rowData.NoLote, Estado: rowData.NoLote }),
    },
    {
      // Comment
      field: "NoLoteInt",
      header: "No. Lote Interno",
      headerEn: "Internal Lot No.",
      className: "colum-width-Xlarge",
      body: (rowData) => rowData.NoLoteInt,
      frozen: "frozen",
      className: "large",
      hidden: userAuth.IdRol === 1,
    },
    {
      header: "Proveedor",
      headerEn: "Proveedor",
      field: "CustomerName",
      className: "large",
      frozen: true,
      body: (rowData) => ({ ID: rowData.NoLote, Estado: rowData.NoLote }),
    },
  ];

  const table = {
    Data: lotes,
    loading: loading,
    Columns: columns,
    onCellClicked: (e) => onChange(e, rowData),
  };

  useEffect(() => {
    fetchData();
  }, [IdVendor]);

  return (
    <div style={{ maxWidth: "50vw" }}>
      <div className="p-inputgroup">
        <InputText
          value={rowData.NumeroIngreso}
          disabled
          placeholder="No. Lote"
          onClick={(e) => op.current.toggle(e)}
        />
        <Button
          ref={buttom}
          icon="pi pi-chevron-down"
          style={{ padding: "0.5rem 0.3rem" }}
          type="button"
          onClick={(e) => op.current.toggle(e)}
        />
      </div>

      <OverlayPanel
        ref={op}
        showCloseIcon
        dismissable={false}
        className="OverLotes"
        onHide={close}
      >
        <div style={{ width: 650, height: 300 }}>
          <AgGrid table={table} />
        </div>
      </OverlayPanel>
    </div>
  );
};

export default LotesOverlayPanel;
